// extracted by mini-css-extract-plugin
export default {"root":"FieldCurrencyInput_root__JuXIG","label":"FieldCurrencyInput_label__0twBM","input":"FieldCurrencyInput_input__ivvM6"};